enum ClickTypes {
  Action = "action",
  Navigation = "navigation",
}

export default ClickTypes;
